import { render } from "./schedule-time-table.vue?vue&type=template&id=596607da"
import script from "./schedule-time-table.vue?vue&type=script&lang=js"
export * from "./schedule-time-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__